var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
export var CastVoteStatus;
(function (CastVoteStatus) {
    CastVoteStatus["IN_PROGRESS"] = "in-progress";
    CastVoteStatus["VALID"] = "valid";
    CastVoteStatus["DISCARDED"] = "discarded";
})(CastVoteStatus || (CastVoteStatus = {}));
var initialState = {};
export var castVotesSlice = createSlice({
    name: "castVotes",
    initialState: initialState,
    reducers: {
        addCastVotes: function (state, action) {
            var _loop_1 = function (castVote) {
                if (!castVote.election_id) {
                    return "continue";
                }
                if (castVote.status === CastVoteStatus.DISCARDED) {
                    state[castVote.election_id] = (state[castVote.election_id] || []).filter(function (cv) { return castVote.id !== cv.id; });
                    return "continue";
                }
                state[castVote.election_id] = __spreadArray(__spreadArray([], (state[castVote.election_id] || []).filter(function (cv) { return castVote.id !== cv.id; }), true), [
                    castVote,
                ], false);
            };
            for (var _i = 0, _a = action.payload; _i < _a.length; _i++) {
                var castVote = _a[_i];
                _loop_1(castVote);
            }
            return state;
        },
    },
});
export var addCastVotes = castVotesSlice.actions.addCastVotes;
export var selectCastVotesByElectionId = function (electionId) { return function (state) {
    return state.castVotes[electionId] || [];
}; };
export var canVoteSomeElection = function () {
    return function (state) {
        var ballotStyleElectionIds = Object.keys(state.ballotStyles);
        var elections = ballotStyleElectionIds
            .map(function (electionId) { return state.elections[electionId]; })
            .filter(function (election) { return !!election; });
        return elections.some(function (election) {
            var _a, _b;
            if ((_a = state.extra.completedAcclaimedElections) === null || _a === void 0 ? void 0 : _a[election.id]) {
                return false;
            }
            var electionCastVotes = ((election === null || election === void 0 ? void 0 : election.id) && state.castVotes[election.id]) || [];
            var numAllowedRevotes = (_b = election === null || election === void 0 ? void 0 : election.num_allowed_revotes) !== null && _b !== void 0 ? _b : 1;
            // If num_allowed_revotes is 0, allow voting
            if (numAllowedRevotes === 0) {
                return true;
            }
            return electionCastVotes.length < numAllowedRevotes;
        });
    };
};
export default castVotesSlice.reducer;
